"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regExps = void 0;
exports.regExps = {
    email: /^( )*(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))( )*$/i,
    phone: /^(\+7|7|8)?[\s-]?\(?[0-9]{3}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/,
    phoneOptional: /^(\+7 \(___\) ___ __ __)|(\+7|7|8)?[\s-]?\(?[0-9]{3}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/,
    url: /^(?:http(s)?:\/\/)?(www.)?([0-9a-zа-я.-]+(?:\.[0-9a-zа-я.-]+)+[a-z0-9а-я\-._~:/?#[\]@!$&'()*+,;=.]+)$/,
};
//# sourceMappingURL=regExps.js.map